



export const locale = {
    lang: 'fr',
    data: {
	'FAVORIS':{
'TITLE':'',
'SEARCH':'Rechercher',

'NAME':'Name',
'SEARCH_TEXT':'Rechercher une application ou une page',
'NO_SHORTCUTS':'Pas encore de raccourcis !',
'ADD_SHORTCUT':'Cliquez pour ajouter/supprimer un raccourci',

}
}
};